import SetitngsTag from './SettingsTag'

export default SetitngsTag
